import React, { useState, useEffect } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Button,
    CircularProgress,
    Alert,
    Paper
} from '@mui/material';
import { useTFA } from '../context/TFAContext';
import OTPInput from './OTPInput';

const TFASetup = () => {
    const { setupTFA, enableTFA, qrCode, isLoading } = useTFA();
    const [otp, setOtp] = useState('');
    const [error, setError] = useState('');
    const [step, setStep] = useState(1);

    useEffect(() => {
        if (step === 1) {
            setupTFA();
        }
    }, [step]);

    const handleVerify = async () => {
        try {
            setError('');
            await enableTFA(otp);
            setStep(3);
        } catch (err) {
            setError('Érvénytelen kód. Kérjük próbálja újra.');
        }
    };

    if (isLoading && step === 1) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Card>
            <CardContent>
                <Typography variant="h5" gutterBottom>
                    Kétfaktoros hitelesítés beállítása
                </Typography>

                {step === 1 && (
                    <>
                        <Typography variant="body1" paragraph>
                            Olvassa be a QR kódot a Google Authenticator alkalmazással
                        </Typography>
                        {qrCode && (
                            <Box display="flex" justifyContent="center" my={3}>
                                <Paper elevation={3} sx={{ p: 2 }}>
                                    <img
                                        src={`data:image/png;base64,${qrCode}`}
                                        alt="TFA QR Code"
                                        style={{ width: '200px', height: '200px' }}
                                    />
                                </Paper>
                            </Box>
                        )}
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setStep(2)}
                            fullWidth
                        >
                            Tovább
                        </Button>
                    </>
                )}

                {step === 2 && (
                    <>
                        <Typography variant="body1" paragraph>
                            Kérjük, írja be a Google Authenticator alkalmazásból kapott 6 számjegyű kódot
                        </Typography>
                        <OTPInput
                            value={otp}
                            onChange={setOtp}
                            error={!!error}
                        />
                        {error && (
                            <Alert severity="error" sx={{ mb: 2 }}>
                                {error}
                            </Alert>
                        )}
                        <Box display="flex" gap={2}>
                            <Button
                                variant="outlined"
                                onClick={() => setStep(1)}
                                fullWidth
                            >
                                Vissza
                            </Button>
                            <Button
                                variant="contained"
                                onClick={handleVerify}
                                disabled={otp.length !== 6}
                                fullWidth
                            >
                                Ellenőrzés
                            </Button>
                        </Box>
                    </>
                )}

                {step === 3 && (
                    <Alert severity="success">
                        A kétfaktoros hitelesítés sikeresen beállítva!
                    </Alert>
                )}
            </CardContent>
        </Card>
    );
};

export default TFASetup; 